/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-brick.html";
import "../../ns-badge/ns-badge.js";

export class NsBrick extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  static get observers() {
    return [
      "_badgesArrayChanged(badges)",
      "_profilePhotoChanged(profilePhoto)"
    ];
  }

  static get is() {
    return "ns-brick";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      badges: {
        type: Array
      },
      number: Number,
      showMore: String,
      profilePhoto: {
        type: String
      },
      noImg: {
        type: Boolean,
        value: false
      },
      businessName: {
        type: String,
        value: "company name"
      },
      displayName: {
        type: String,
        value: "seller name"
      },
      photos: Array,
      noBadges: {
        type: Boolean,
        value: false
      }
    };
  }

  _badgesArrayChanged(badges) {
    if (badges.length === 0) {
      this.set("noBadges", true);
      this.showMore = "";
    } else {
      this.set("noBadges", false);
    }
    if (badges.length > 3) {
      this.showMore = "show-more";
      this.number = badges.length - 3;
    }
  }

  _profilePhotoChanged(profilePhoto) {
    if (profilePhoto === "") {
      this.noImg = true;
    } else {
      this.noImg = false;
    }
  }

  missingImg() {
    this.set("noImg", true);
  }
}

customElements.define(NsBrick.is, NsBrick);
